// Existing tenants keep their current behavior unless explicitly disabled.
export const NOTI_BYPASS_ENABLED = process.env.REACT_APP_NOTI_BYPASS_ENABLED !== 'false';

export const VERITASON_AGENT_WALLET_TRANSFER_ENABLED = process.env.REACT_APP_VERITASON_AGENT_WALLET_TRANSFER_ENABLED === 'true';
